module.exports = __webpack_public_path__ + "media/images/email/instagram2x (copy)-4384876c8b28abd903a23b48de52a059.png";